module.exports = __webpack_public_path__ + "img/IMG_9621_L_Foamcore.e6854894.jpg";